export enum GigApplicationStatuses {
  NEW = 1,
  ARCHIVED = 2,
}
